import React from "react";

export const AppDataContext = React.createContext({
  // state
  settings: null,
  whyUs: null,
  category: null,
  slider: null,
  blog: null,
  contact: null,
  social: null,
  serviceRegion: null,
  companyInfo: null,
  investorRelations: null,
  history: null,
  about: null,
  certificate: null,
  rnd: null,
  board: null,
  product: null,
  featuredProduct: null,
  sss: null,
  loading: true,
  error: null,
  // i18n
  lang: "tr",
  setLang: () => {},
  // pageConfig
  pageConfig: {},
  // actions
  refreshAll: () => {},

  // yardımcı
  getFromCache: () => null,
});
